import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import Icon from './../Icon';
import classNames from './../../utils/classNames';
import formatTime from './../../utils/formatTime';

import { STATUS_COMPLETE, STATUS_OPEN, STATUS_PROGRESS } from './../../store/orders/actions';

class OrderInfo extends Component {
    renderTemplate() {
        const { order, templates } = this.props;
        const format = order.format;
        if (!format) {
            return 'No template';
        }
        const template = templates[format.toLowerCase()];
        if (!template) {
            return format;
        }
        return (
            <a href={template.location} rel="noopener noreferrer" target="_blank">{format}</a>
        );
    }

    renderDeadline() {

    }

    render() {
        const { order, status } = this.props;
        const momentDeadline = moment(order.pregrader_deadline);
        const deadlineClassName = classNames({ 'error': moment().isAfter(momentDeadline) });
        const pregrader_price = !!order.pregrader_price ? order.pregrader_price.toFixed(2) : '';
        const sources = (!order.sources || order.sources === '0') ? 'Specified in description' : order.sources;

        return (
            <div className="row">
                <ul className="order-info col-2">
                    <li>{order.type} &middot; {order.size} &middot; {order.level}</li>
                    <li>{order.subject}</li>
                    <li>{this.renderTemplate()}</li>
                    <li>Sources: {sources}</li>
                </ul>
                <ul className="order-info col-1 ta-right">
                    <li className={deadlineClassName}><Icon className="svg-icon" iconName="clock" />{formatTime(momentDeadline, 'dt')}</li>
                    {status === STATUS_COMPLETE && <li>Completed</li>}
                    {status === STATUS_OPEN && <li>Available</li>}
                    {status === STATUS_PROGRESS && <li>In-progress</li>}
                    <li><span className="order-cost">${pregrader_price}</span></li>
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    templates: state.settings.templates
});

export default connect(mapStateToProps)(OrderInfo);


// WEBPACK FOOTER //
// ./src/components/order/OrderInfo.js